import { render, staticRenderFns } from "./stock-warehouse.vue?vue&type=template&id=033d707b&scoped=true"
import script from "./stock-warehouse.vue?vue&type=script&lang=js"
export * from "./stock-warehouse.vue?vue&type=script&lang=js"
import style0 from "./stock-warehouse.vue?vue&type=style&index=0&id=033d707b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033d707b",
  null
  
)

export default component.exports